export default __webpack_public_path__ + "static/andrysandcristian@2x-93b8fbf1e72d995b59076262384408b5.png";